import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/CreateEngagement.graphql';
import { Mutation, MutationcreateEngagementArgs } from '../../__generated__/globalTypes';

export const useCreateEngagementMutation = (options?: MutationHookOptions<Mutation, MutationcreateEngagementArgs>) => {
  const [callCreateEngagement, result] = useMutation<Mutation, MutationcreateEngagementArgs>(MUTATION, options);

  return { callCreateEngagement, ...result };
};

export type CreateEngagementMutationFunction = Mutation['createEngagement'];
